<template>
    <div class="position-box bindMail">
        <div class="head">
            <img class="back" v-if="theme" src="@/assets/theme/icon_back.png" @click="goBack" alt="">
            <img class="back" v-else src="@/assets/icon_back.png" @click="goBack" alt="">
            <div class="title">{{$t('bind.title')}}</div>
        </div>
        <div class="cotainer">
            <div class="tips">{{$t('newReg.yx')}}</div>
            <div class="input-box"><input class="input" v-model="email" type="text" :placeholder="$t('lg.email')"></div>
            <div class="tips">{{$t('lg.yzm')}}</div>
            <div class="input-box" v-if="lang == 'ar'"><input class="code" id="fbtain" type="button" @click="getCode" :value="$t('xgdlmm.hqyzm')"><input class="input" v-model="code" type="text" :placeholder="$t('lg.pemcode')"></div>
            <div class="input-box" v-else><input class="input" v-model="code" type="text" :placeholder="$t('lg.pemcode')"><input class="code" id="fbtain" type="button" @click="getCode" :value="$t('xgdlmm.hqyzm')"></div>
            <button class="btn-login btn-bg" @click="sure">{{$t('sztkmm.qr')}}</button>
            <div class="tips-box">{{$t('mbwt.zyts')}}{{$t('bind.ts')}}</div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'bindMail',
    data () {
        return {
          theme: false,
          email: '',
          code: '',
          countdown: 300,
          timer: null,
          count: 1,
          lang: 'en'
        }
    },
    created(){
      this.theme = JSON.parse(localStorage.getItem('theme'));
      this.lang = localStorage.getItem('language') || 'en';
    },
    mounted() {
      $("input").keyup(function(){	//去掉空格
        $(this).val($(this).val().replace(/[, ]/g,''));
      });
    },
    methods: {
       goBack(){
           this.$router.push('/securityCenter')
       },
       sure(){
          var regEmail = /^\S+[@]+\S/;
          var data = {
              email : this.email,
              code : this.code
          }
          if(data.email == "" || data.email == null){
              this.$toast.center(this.$t('lg.email'));
              return false;
          }else if(!regEmail.test(data.email)){
              this.$toast.center(this.$t('tipsNew.emailgsts'));
              return false;
          }
          if(data.code == '' || data.code == null){
              this.$toast.center(this.$t('lg.pcode'));
              return false;
          }
          if(this.count == 1){
            this.count = 0;
          }else{
              return false;
          }
          this.$ajax.post('/web/bindemail',data).then((res) => {
              let resData = res.data;
              if(resData.code == 0 || resData.code == 4 || resData.code == 7){
                this.$toast.center(resData.message);
                setTimeout(() => {
                    this.count = 1;
                    this.$router.push('/securityCenter')
                }, 1000)
              }else{
                  this.count = 1;
                  this.$toast.center(resData.message);
                  return;
              }
          }).catch(function(err){
              console.log(err)
          })
       },
       //获取手机邮箱验证码
       getCode(){
           let params = {
               account: this.email,
               type: '',
               token: 1
           }
           if(this.email == '' || this.email == null){
              this.$toast.center(this.$t('lg.email'));
              return;
           }
           if(this.count == 1){
              this.count = 0;
            }else{
                return false;
            }
           this.$ajax.get('/web/getCode',{params}).then((res) => {
                let resData = res.data;
                if(resData.code == 1){
                    this.$toast.center(resData.message);
                    this.count = 1;
                    return;
                }else{
                  this.count = 1;
                  this.settime()
                }

            }).catch(function(err){
                console.log(err)
            })
       },
       settime(){
           let generate_code = $("#fbtain");
           if (this.countdown == 0) {
                generate_code.attr("disabled", false);
                generate_code.val(this.$t('xgdlmm.hqyzm'));
                generate_code.css('color', '#5890bd');
                this.countdown = 300;
                return false;
            } else {
                generate_code.attr("disabled", true);
                generate_code.css('color', '#b6bfc4');
                generate_code.val(this.countdown + ' s');
                this.countdown--;
            }
            this.timer = setTimeout(() => {
                this.settime();
            }, 1000);
       },
    },
    beforeDestroy(){
      clearTimeout(this.timer);
      this.timer = null;
    }
}
</script>
<style scoped>
    .head{
        position: fixed;
        top: 0;
        width: 100%;
        height: 1.6rem;
        color: #000;
        font-size: .56rem;
        line-height: 1.6rem;
        background: #fff;
        text-align: center;
    }
    .head .back{
        position: absolute;
        left: .4rem;
        top: 50%;
        width: .5rem;
        margin-top: -.4rem;
    }
    .position-box{
        position: absolute;
        width: 100%;
        height: 100%;
        background: #fff;
    }
    .cotainer{
        position: absolute;
        left: .45rem;
        right: .45rem;
        top: 2.4rem;
        bottom: 0;
        background: #fff;
        overflow-y: scroll;
    }
    .cotainer .tips{
        padding: .54rem 0 .26rem;
        color: #000;
        font-size: .4rem;
    }
    .cotainer .input-box{
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: .32rem 0;
        border-bottom: .01rem solid #ececec;
    }
    .cotainer .input-pwd{
        margin-top: .76rem;
    }
    .cotainer .input-box .input{
        flex: 1;
        height: 100%;
        color: #000;
        font-size: .48rem;
    }
    .cotainer .input-box .input::placeholder{
        color: #d7d7d7;
        font-size: .42qrem;
    }
    .cotainer .input-box .code{
        color: #588bf8;
        font-size: .42rem;
    }
    .cotainer .item-box{
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: .5rem 0 1.2rem;
        font-size: .4rem;
    }
    .cotainer .btn-login{
        display: block;
        width: 100%;
        margin-top: 1.7rem;
    }
    .cotainer .tips-box{
        padding: .6rem 0;
        color: #000;
        font-size: .36rem;
    }
</style>



// WEBPACK FOOTER //
// src/pages/bindMail.vue